import { Modelo } from '@ext/index';
import * as Types from './Resultado.types';
import moment, { Moment } from 'moment';
import { Respuesta } from '@/__env/lib/Cursos/Respuestas';

export class IResultado extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Curso: number = 0;
    public Usuario: number = 0;
    public Correctas: number = 0;
    public Incorrectas: number = 0;
    public Contestadas: number = 0;
    public NoContestadas: number = 0;
    public Total: number = 0;
    public Calificacion: number = 0;
    public Finalizado: boolean = false;
    public FechaIniciado: Moment = moment( '' );
    public FechaFinalizado: Moment = moment( '' );
    public UltimaPregunta: number;

    public Respuestas: Respuesta[] = [];

    public get Duracion(): number
    {
        console.log( this.FechaFinalizado.diff( this.FechaIniciado, 'hour' ) );
        console.log( this.FechaFinalizado );
        console.log( this.FechaIniciado );
        if ( this.Finalizado )
            return this.FechaFinalizado.diff( this.FechaIniciado, 'hours' );
    }

    public get Progreso(): number
    {
        return this.UltimaPregunta / this.Total * 100;
    }

    public set(): boolean
    {

        this.Curso = !this.Json.curso ? 0 : this.Json.curso;
        this.Usuario = !this.Json.usuario ? 0 : this.Json.usuario;

        this.Correctas = !this.Json.correctas ? 0 : this.Json.correctas;
        this.Incorrectas = !this.Json.incorrectas ? 0 : this.Json.incorrectas;

        this.Contestadas = !this.Json.contestadas ? 0 : this.Json.contestadas;
        this.NoContestadas = !this.Json.no_contestadas ? 0 : this.Json.no_contestadas;
        this.Total = !this.Json.total ? 0 : this.Json.total;
        this.Calificacion = !this.Json.calificacion ? 0 : this.Json.calificacion;
        this.Finalizado = this.Json.finalizado == 'S';

        this.FechaIniciado = !this.Json.fecha_iniciado ? moment( '' ) : moment( this.Json.fecha_iniciado );
        this.FechaFinalizado = !this.Json.fecha_finalizado ? moment( '' ) : moment( this.Json.fecha_finalizado );

        this.UltimaPregunta = !this.Json.ultima_pregunta ? 0 : this.Json.ultima_pregunta;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );

    }
}

class Vista
{
    constructor( Model: IResultado )
    {
        this.Model = Model;
    }

    public Model: IResultado;
    public get Resultado(): string
    {
        if ( this.Model.Calificacion <= 40 )
            return 'desaprobado';
        else if ( this.Model.Calificacion <= 70 )
            return 'aceptable';
        else if ( this.Model.Calificacion < 90 )
            return 'aprobado';
        else if ( this.Model.Calificacion >= 90 )
            return 'perfecto';
    }

    public get Color(): string
    {
        if ( this.Model.Calificacion <= 40 )
            return 'error';
        else if ( this.Model.Calificacion <= 70 )
            return 'light-blue';
        else if ( this.Model.Calificacion < 90 )
            return 'light-blue';
        else if ( this.Model.Calificacion >= 90 )
            return 'success';
    }

    public get Duracion(): string
    {
        if ( !this.Model.Finalizado )
            return '';

        if ( this.Model.Duracion <= 0 )
            return 'menos de una hora';
        else if ( this.Model.Duracion >= 24 )
            return this.Model.FechaFinalizado.diff( this.Model.FechaIniciado, 'days' ).toFixed( 0 ) + ' día(s)';
        else
            return this.Model.Duracion.toFixed( 0 ) + ' hora(s)';
    }
}